import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import InfoCircleFilledSvg from "@ant-design/icons-svg/es/asn/InfoCircleFilled";
import AntdIcon from "../components/AntdIcon";
var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InfoCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  InfoCircleFilled.displayName = 'InfoCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(InfoCircleFilled);